<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Flag / Region / ROE</title>
    <defs>
      <circle id="path-1" cx="12" cy="12" r="12"></circle>
    </defs>
    <g
      id="Flag-/-Region-/-ROE"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <mask id="mask-2" fill="white">
        <use xlink:href="#path-1"></use>
      </mask>
      <g id="Mask" fill-rule="nonzero"></g>
      <g id="eu" mask="url(#mask-2)">
        <polygon
          id="Path"
          fill="#003399"
          points="0 0 24 0 24 24 0 24"
        ></polygon>
        <g id="Group" transform="translate(2.518519, 2.631019)" fill="#FFCC00">
          <g id="d" transform="translate(7.111111, 0.000000)">
            <g id="b" transform="translate(1.185185, 1.185185)">
              <polygon
                id="a"
                points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
              ></polygon>
              <g
                id="a-link"
                transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
              </g>
            </g>
            <g id="c">
              <g
                id="b"
                transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g
                id="b"
                transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
            </g>
            <g
              id="c"
              transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
            >
              <g
                id="b"
                transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g
                id="b"
                transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
            </g>
          </g>
          <g id="d" transform="translate(7.111111, 14.222222)">
            <g id="b" transform="translate(1.185185, 1.185185)">
              <polygon
                id="a"
                points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
              ></polygon>
              <g
                id="a-link"
                transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
              </g>
            </g>
            <g id="c">
              <g
                id="b"
                transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g
                id="b"
                transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
            </g>
            <g
              id="c"
              transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
            >
              <g
                id="b"
                transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g
                id="b"
                transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
              >
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
            </g>
          </g>
          <g id="e">
            <g id="d" transform="translate(0.000000, 7.111111)">
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="d"
              transform="translate(6.013167, 3.376780) rotate(-144.000000) translate(-6.013167, -3.376780) translate(3.642797, 1.006410)"
            >
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="d"
              transform="translate(3.376780, 6.013167) rotate(144.000000) translate(-3.376780, -6.013167) translate(1.006410, 3.642797)"
            >
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="d"
              transform="translate(3.378094, 13.141333) rotate(72.000000) translate(-3.378094, -13.141333) translate(1.007724, 10.770962)"
            >
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="d"
              transform="translate(5.950356, 15.526843) rotate(72.000000) translate(-5.950356, -15.526843) translate(3.579986, 13.156473)"
            >
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g
            id="e"
            transform="translate(14.222222, 9.481481) scale(-1, 1) translate(-14.222222, -9.481481) translate(9.481481, 0.000000)"
          >
            <g id="d" transform="translate(0.000000, 7.111111)">
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="d"
              transform="translate(6.013167, 3.376780) rotate(-144.000000) translate(-6.013167, -3.376780) translate(3.642797, 1.006410)"
            >
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="d"
              transform="translate(3.376780, 6.013167) rotate(144.000000) translate(-3.376780, -6.013167) translate(1.006410, 3.642797)"
            >
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="d"
              transform="translate(3.378094, 13.141333) rotate(72.000000) translate(-3.378094, -13.141333) translate(1.007724, 10.770962)"
            >
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
            <g
              id="d"
              transform="translate(5.950356, 15.526843) rotate(72.000000) translate(-5.950356, -15.526843) translate(3.579986, 13.156473)"
            >
              <g id="b" transform="translate(1.185185, 1.185185)">
                <polygon
                  id="a"
                  points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                ></polygon>
                <g
                  id="a-link"
                  transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                </g>
              </g>
              <g id="c">
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
              <g
                id="c"
                transform="translate(2.370370, 2.370370) scale(-1, 1) translate(-2.370370, -2.370370) "
              >
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(72.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
                <g
                  id="b"
                  transform="translate(2.370370, 2.370370) rotate(144.000000) translate(-2.370370, -2.370370) translate(1.185185, 1.185185)"
                >
                  <polygon
                    id="a"
                    points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                  ></polygon>
                  <g
                    id="a-link"
                    transform="translate(1.185185, 1.185185) scale(-1, 1) translate(-1.185185, -1.185185) "
                  >
                    <polygon
                      id="a"
                      points="1.18518516 0 0.829629609 1.18518516 1.42222219 1.30370367"
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>